import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import {
  CardTitle,
  Centered,
  CenteredNoMargin,
  DateTitle,
  InformationText
} from "../CardsStyled";
import { CenteredDescription } from "./CardCoreStyled";
import { getTranslatedDate } from "utils/date-utils";
import { useTranslate } from "hooks/translation-hooks";

export const CardCore = ({
  description,
  rawEventDate,
  statusClass,
  additionalDescription,
  title,
  hideDate,
  appointmentProposalStart,
  appointmentProposalEnd
}) => {
  const t = useTranslate();
  const { i18n } = useTranslation();
  const getMinutes = minutes =>
    minutes.toString().length === 1 ? `0${minutes}` : minutes;
  return (
    <>
      <Centered>
        <CardTitle>{title}</CardTitle>
      </Centered>
      <Centered>
        <InformationText>{additionalDescription}</InformationText>
      </Centered>
      {!hideDate && rawEventDate && (
        <CenteredNoMargin>
          <DateTitle className={statusClass}>
            {`${getTranslatedDate(rawEventDate, i18n.language)}`.toUpperCase()}
          </DateTitle>
        </CenteredNoMargin>
      )}
      {!hideDate && description && (
        <CenteredDescription>
          {appointmentProposalStart && appointmentProposalEnd
            ? `${t("appointment-description_first")}${new Date(
                appointmentProposalStart
              ).getHours()}:${getMinutes(
                new Date(appointmentProposalStart).getMinutes()
              )}${t("appointment-description_second")}${new Date(
                appointmentProposalEnd
              ).getHours()}:${getMinutes(
                new Date(appointmentProposalEnd).getMinutes()
              )} `
            : description}
        </CenteredDescription>
      )}
    </>
  );
};

CardCore.propTypes = {
  description: PropTypes.string,
  rawEventDate: PropTypes.string,
  statusClass: PropTypes.string,
  additionalDescription: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  hideDate: PropTypes.bool
};

CardCore.defaultProps = {
  description: "",
  rawEventDate: "",
  statusClass: "",
  hideDate: false
};

export default CardCore;
